<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="reports"
      @on-row-click="printReport"
    />

    <!-- Gate de Assinatura -->
    <signature-gate-modal
      ref="signatureGate"
      :entity-data="fullOther"
      store-name="othersAdministrativeModule"
      action-name="editOtherDadosPessoais"
      @confirmed="onSignatureConfirmed"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import mixinsGlobal from '@/mixins'
import SignatureGateModal from '@/components/report/SignatureGateModal.vue'

export default {
  name: 'ReportOther',
  components: {
    VueGoodTable,
    SignatureGateModal,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('othersAdministrativeModule', ['fullOther']),
  },
  data() {
    return {
      reports: [],
      columns: [
        {
          label: 'Relatório',
          field: 'nomeAmigavel',
        },
      ],
      report: null,
    }
  },
  mounted() {
    this.$store
      .dispatch('reportModule/listagemRelatorios', this.$route.params.id)
      .then(response => {
        this.reports = response.data
      })
  },
  methods: {
    printReport(params) {
      this.report = {
        nome: params.row.nome,
        valor: [parseInt(this.$route.params.id)],
        exigeAssinatura: params.row.exigeAssinatura,
      }

      if (this.report.exigeAssinatura) {
        this.$refs.signatureGate.trigger(this.report)
        return
      }

      this.executePrint(this.report)
    },
    onSignatureConfirmed({ report, signature }) {
      report.assinatura = signature
      this.executePrint(report)
    },
    executePrint(report) {
      this.$store
        .dispatch('reportModule/printReport', report)
        .then(response => {
          if (response.error) {
            this.showMessageSuccess('Limite Excedido', response.message)
          }
          if (typeof response.data === 'string') {
            this.openNewAbaBase64(response.data)
          }
        })
    },
  },
}
</script>
